import { LocalBusinessJsonLd, LogoJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

const StoreJsonLd = ({
  metaDescription,
  metaTitle,
  storeDomain,
  storeImage,
  storeRating = null,
  storeRatingCount = null,
}) => {
  const storeUrl = `https://${storeDomain}`;

  return (
    <>
      <LocalBusinessJsonLd
        address={{
          streetAddress: '',
          addressLocality: '',
          addressRegion: '',
          postalCode: '',
          addressCountry: '',
        }}
        description={metaDescription}
        images={[storeImage]}
        name={metaTitle}
        rating={
          storeRating !== null && storeRating > 0
            ? {
                ratingValue: storeRating,
                ratingCount: storeRatingCount,
              }
            : null
        }
        type="Store"
        url={storeUrl}
      />
      <LogoJsonLd logo={storeImage} url={storeUrl} />
    </>
  );
};

StoreJsonLd.propTypes = {
  metaDescription: PropTypes.string.isRequired,
  metaTitle: PropTypes.string.isRequired,
  storeDomain: PropTypes.string.isRequired,
  storeImage: PropTypes.string.isRequired,
  storeRating: PropTypes.number,
  storeRatingCount: PropTypes.number,
};

export default StoreJsonLd;
